import React from 'react';
import { Icon } from '../Icon';
import styles from './menu.module.scss';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

const DotsBtn = ({ onClick, disabled, className }) => {
  const { t } = useTranslation();

  return (
    <button className={cx(styles.btn, { [styles.disabled]: disabled }, className)} onClick={onClick} disabled={disabled} aria-label={t('accessibility.more')}>
      <Icon className="largeIconBtnIcon" src="more_vert" />
    </button>
  );
};

export default DotsBtn;
